const VisitScheduleList = resolve => require(['@/views/VisitSchedule/List'], resolve)

export default [
  {
    name: 'VisitSchedule_list',
    path: '/visitSchedule/list',
    component: VisitScheduleList,
    meta: {
      keepAlive: false,
      title: '拜访计划',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/visitSchedule.js